import React, { Fragment } from "react"
import { appPlayerProfilePath } from "../paths"
import { Round, TeamRound } from "../types"
import { formatScore, thru } from "../util"

interface IndividualLeaderboardProps {
  round: Round
  teamRounds: TeamRound[]
}

export default function IndividualLeaderboard({ round, teamRounds }: IndividualLeaderboardProps) {
  const players = []
  const teamComplete = {}
  for (const tr of teamRounds) {
    for (const p of tr.players) {
      if (!p.canceled && p.holesCompleted) {
        players.push(p)
        teamComplete[p.id] = tr.complete
      }
    }
  }
  players.sort((a, b) => {
    if (a.position.rank < b.position.rank) {
      return -1
    } else if (a.position.rank > b.position.rank) {
      return 1
    } else {
      return a.holesCompleted < b.holesCompleted ? -1 : 1
    }
  })

  const backPath = `${window.location.pathname}${window.location.search}`

  function goToPlayerProfile(sqid: string) {
    window.location.href = appPlayerProfilePath(sqid, {
      back_path: backPath,
      round_id: round.id,
      league_id: round.league.id
    })
  }

  return (
    <table style={{ width: "100%" }}>
      <thead>
        <tr>
          <th style={{ width: "1%", borderRight: "none" }}></th>
          <th style={{ width: "96%", borderLeft: "none", borderRight: "none" }}>Player</th>
          <th style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>Score</th>
          <th style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>Thru</th>
          <th style={{ width: "1%", textAlign: "right", borderLeft: "none" }}>Points</th>
        </tr>
      </thead>
      <tbody>
        {players.map((p, i) => {
          return (
            <Fragment key={i}>
              <tr
                style={{
                  backgroundColor: i % 2 === 0 ? "#fff" : "#fafafa",
                  cursor: p.user.sqid ? "pointer" : "default"
                }}
                onClick={() => {
                  if (p.user.sqid) goToPlayerProfile(p.user.sqid)
                }}
              >
                <td style={{ width: "1%", textAlign: "center", borderRight: "none" }}>{p.position.label}</td>
                <td style={{ width: "96%", borderLeft: "none", borderRight: "none" }}>{p.user.name}</td>
                <td style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>
                  {formatScore(p.netScoreRelativeToPar)}
                </td>
                <td style={{ width: "1%", textAlign: "right", borderLeft: "none", borderRight: "none" }}>
                  {thru(p.holesCompleted, teamComplete[p.id])}
                </td>
                <td style={{ width: "1%", textAlign: "right", borderLeft: "none" }}>{p.position.points}</td>
              </tr>
            </Fragment>
          )
        })}
      </tbody>
    </table>
  )
}
